import BaseController from "controllers/backend/base"

import SelectVehicleWidget from "widgets/select/selectVehicleWidget"

class Controller extends BaseController {
  call() {
    super.call()
    bindVehicleTrimSelect.call(this)
  }
};

var bindVehicleTrimSelect = function() {
  let elem = this.root.find('form')
  this.vehicles = new SelectVehicleWidget(elem)
  this.vehicles.setState({selector: 'select#sale_vehicle_id'})
}

export default Controller;
